<template>
  <nav class="in-place-container" :style="style">
    <div class="sticky-container flex flex-col" :style="{ height: sidenavHeight }">
      <slot />
    </div>
  </nav>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';

const props = defineProps({
  minWidth: { type: String },
  width: { type: String, required: true },
  maxWidth: { type: String },
});

const style = {
  '--width': props.width,
  '--min-width': props.minWidth || props.width,
  '--max-width': props.maxWidth || props.width,
};
const visibleFooterHeight = ref(0);
const sidenavHeight = ref('0px');

function adjustSidenavHeight() {
  const footer = document.getElementById('footer-section');
  const headerElement = document.getElementById('portal-navbar-section');
  const viewportHeight = window.innerHeight;
  sidenavHeight.value = `calc(${viewportHeight}px - ${headerElement?.offsetHeight || 0}px)`;
  if (!footer) return;

  const rect = footer.getBoundingClientRect();
  const windowHeight = window.innerHeight;

  const fullyVisible = rect.top >= 0 && rect.bottom <= windowHeight;
  const completelyOutOfView = rect.top >= windowHeight || rect.bottom <= 0;

  if (completelyOutOfView) {
    visibleFooterHeight.value = 0;
  } else if (fullyVisible) {
    visibleFooterHeight.value = rect.height;
  } else {
    const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
    visibleFooterHeight.value = Math.max(0, visibleHeight);
  }
  sidenavHeight.value = `calc(${viewportHeight}px - ${headerElement?.offsetHeight}px - ${visibleFooterHeight.value}px)`;
}

onMounted(() => {
  adjustSidenavHeight();
  window.addEventListener('scroll', adjustSidenavHeight);
  window.addEventListener('resize', adjustSidenavHeight);
});

onUnmounted(() => {
  window.removeEventListener('scroll', adjustSidenavHeight);
  window.removeEventListener('resize', adjustSidenavHeight);
});
</script>

<style scoped lang="scss">
.in-place-container,
.sticky-container {
  min-width: var(--min-width);
  width: var(--width);
  max-width: var(--max-width);
  height: calc(100vh - var(--bifrost-header-height));
}

.in-place-container {
  position: relative;
}

.sticky-container {
  position: fixed;
  top: var(--bifrost-header-height);
  overflow-y: auto;
}
</style>
